import script from "./bookingsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./bookingsReport.vue?vue&type=script&setup=true&lang=js"

import "./bookingsReport.vue?vue&type=style&index=0&id=28bddbd6&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bddbd6"]])

export default __exports__